import React from 'react';
export function FAQ() {
  const faqs = [{
    q: 'Is this just Sleep Training?',
    a: 'No. "Training" implies a struggle. This is biological regulation based on infant neurology.'
  }, {
    q: 'Do I have to let my baby cry?',
    a: 'No. The goal of the Bridge is to prevent the stress spike that leads to crying in the first place.'
  }, {
    q: 'How soon will I see results?',
    a: 'Most parents see a change in the baby\'s "tension level" the very first time they use the 60bpm bottom-patting and hand-anchor technique.'
  }, {
    q: 'What if my baby has reflux?',
    a: 'The C-tuck and hand-anchor are designed to be used in conjunction with any upright-positioning your doctor has recommended.'
  }];
  return <section className="bg-cream py-24 px-6" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <h2 className="text-3xl md:text-4xl font-serif text-center mb-12" data-id="element-15">
          Frequently Asked Questions
        </h2>

        <div className="space-y-6" data-id="element-16">
          {faqs.map((faq, index) => <div key={index} className="bg-white p-6 md:p-8 rounded-xl shadow-sm border border-sage/10" data-id="element-17">
              <h4 className="text-xl font-serif font-semibold mb-3" data-id="element-18">{faq.q}</h4>
              <p className="font-sans text-charcoal/80 leading-relaxed" data-id="element-19">
                {faq.a}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}